import { usePermissionsStore } from "@/shared";
import { clearTokensLocalStorage } from "./LocalStorage";
import { queryClient } from "@/App";

const rbacUrl = import.meta.env.VITE_RBAC_URL;
const clientID = import.meta.env.VITE_RBAC_CLIENT_ID;

export const redirectToLogin = () => {
  window.location.href = `${rbacUrl}/?clientId=${clientID}`;
};

export const logout = () => {
  clearTokensLocalStorage();
  redirectToLogin();
  queryClient.clear();
  usePermissionsStore.getState().clearPermissions();
};
